export default __webpack_public_path__ + "resources/icons/n421-3b17.png";